<template>
	<!-- 登录页 -->

	<div class="login-wrap">
		<!-- 头部 -->
		<img :src="require('../../../assets/img/'+configimg)" class="lefticon" v-if="notemptyandnull(configimg)" />
		<div class="header" style="display: flex;justify-content: center;align-items: center; height:100%;">
			<div class="top-header">
				<div>{{title}}</div>
				<div>{{englishtitle}}</div>
				<img src="../../../assets/img/logimg.png" />
			</div>
			<div class="line" style="width:1px;height: 300px;background-color: #3f5063;margin-left: 60px;"></div>
			<div style="display: flex;flex-direction: column;justify-content: space-between; margin-left: 30px;">
				<div style="color: #FFFFFF; font-size: 18px;margin-top: 60px;">用户注册/Register</div>
				<div style=" margin-top:20px">
					<el-form :model="registerParam" :rules="rules" ref="registerParam" label-width="0px" class="ms-content">
						<!-- 公司名称 -->
						<div style="display: flex;">
							<img src="../../../assets/img/loginicon1.png" class="imgicon" />
						<el-form-item prop="companyName" class="FormInput">
								<el-input v-model="registerParam.companyName" placeholder="请输入公司名称" class="elinput"></el-input>
						</el-form-item>
						</div>
						<div style="display: flex;">
							<img src="../../../assets/img/loginicon2.png" class="imgicon" />
						<el-form-item prop="taxNumber" class="FormInput">
								<el-input v-model="registerParam.taxNumber" placeholder="请输入纳税人识别号" class="elinput"></el-input>
						</el-form-item>
						</div>
						<div style="display: flex;">
							<img src="../../../assets/img/loginicon3.png" class="imgicon" />	
						<el-form-item prop="name" class="FormInput">
							
								<el-input v-model="registerParam.name" placeholder="请输入联系人姓名" class="elinput"></el-input>
							
						</el-form-item>
						</div>
						<div style="display: flex;">
							<img src="../../../assets/img/loginicon4.png" class="imgicon" />
						<el-form-item prop="phone" class="FormInput">
							
								<el-input v-model="registerParam.phone" placeholder="请输入联系人手机号" class="elinput"></el-input>
							
						</el-form-item>
						</div>
						<!-- 图文验证 -->
						<div class="FormInput" style="display: flex;">
							<img src="../../../assets/img/loginicon5.png" class="imgicon" />
						<el-form-item prop="sign" class="FormInput">
							<div class="codestyle" @click="sendSMS">
									<span v-show="show">获取验证码</span>
									<span v-show="!show" class="count">{{ count }}</span>
							</div>
								<el-input class="elinput" type="verify" placeholder="请输入验证码" v-model="registerParam.sign" @keyup.enter.native="onSubmit('param')"></el-input>
								
						</el-form-item>
						</div>
						<div style="margin-top:20px" class="xieyi">
							<el-checkbox v-model="checked" checked></el-checkbox>
							<div style="margin-left: 10px;color: #FFFFFF;">我已认真阅读并同意税务服务平台</div>
							<div style="cursor: pointer;">《用户使用协议》</div>
						</div>
					</el-form>
				</div>
				<div
					@click="submitForm()"
					style="width:400px;height: 40px;background-color: #3198FF;border-radius: 20px; text-align: center;line-height: 40px;color: #FFFFFF;font-size: 14px;margin-top:30px"
				>
					注册
				</div>
				<div class="buttomtologin">
					已有账号 <span @click="forlogin">快速登录</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
//var Base64 = require('js-base64').Base64
import configHttp from '../../../../configHttp.js'
export default {
	name: 'Login',
	data: function() {
		return {
			show: true,
			count: '',
			timer: null,
			registerParam: {
				companyName: '',
				taxNumber: '',
				name: '',
				phone: '',
				sign: ''
			},
			rules: {
				companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
				taxNumber: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }, { validator: this.validateCustomersbh, trigger: 'blur' }],
				name: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
				phone: [{ required: true, message: '请输入联系人手机号', trigger: 'blur' }, { validator: this.validatePhone, trigger: 'blur' }],
				sign: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
			},
			title:"",
			englishtitle:"",
			beianhao:"",
			checked: true,
			configimg:""
		};
	},
	created() {
		this.title=configHttp.title
		this.englishtitle=configHttp.englishtitle
		this.beianhao=configHttp.beianhao
		this.configimg=configHttp.img
	},
	methods: {
		forlogin(){
			this.$router.push('/login');
		},
		/* 获取验证码 */
		sendSMS() {
			//忽略手机号
			this.rules.sign[0].validator = (rule, value, callback) => {
				callback();
			};
			this.$refs['registerParam'].validate(valid => {
				if (valid && this.show) {
					let params = {
						phone: this.registerParam.phone
					};
					this.$https.fetchPost('sys/register/sendSms', params).then(res => {
						if (res.data.success) {
							this.getCode();
						}
					});
				}
			});
		},

		/* 验证码倒计时 */
		getCode() {
			const TIME_COUNT = 60;
			if (!this.timer) {
				this.count = TIME_COUNT;
				this.show = false;
				this.timer = setInterval(() => {
					if (this.count > 0 && this.count <= TIME_COUNT) {
						this.count--;
					} else {
						this.show = true;
						clearInterval(this.timer);
						this.timer = null;
					}
				}, 1000);
			}
		},
		submitForm() {
			
			this.rules.sign[0] = { required: true, message: '请输入验证码', trigger: 'blur' };
			this.$refs['registerParam'].validate(valid => {
				if (valid) {
					if (this.checked) {
						let params = this.registerParam;
						this.$https.fetchPost('sys/register/doRegister', params).then(res => {
							if (res.data.success) {
								this.registerParam = {};
								this.$alert('提交注册申请成功，请耐心等待平台管理员审核，审核结果将以手机短信形式通知您。', '注册成功', {
								          confirmButtonText: '确定',
								          callback: action => {
								            
								          }
								        });
							}else{
								this.$message.error(res.data.message);
							}
						});
					} else {
						this.$message.error('请先同意协议');
					}
				}
			});
		},
		xieyiDialog() {
			this.$alert('这是一段内容', '协议', {
				confirmButtonText: '同意',
				callback: action => {
					if (action === 'confirm') {
						this.checked = true;
						this.$forceUpdate();
					}
				}
			});
		}
	}
};
</script>

<style scoped>
	@media screen and (max-width: 1441px) {
	    .lefticon{
	    	width: 134.4px;
	    	height: 54.8px;
	    	left: 20px;
	    	top: 20px;
	    	position: absolute;
	    }
	}
	@media screen and (min-width: 1441px) {
	    .lefticon{
	    	width: 168px;
	    	height: 68.5px;
	    	left: 80px;
	    	top: 80px;
	    	position: absolute;
	    }
	}
	.buttomtologin{
		display: flex;
		justify-content: flex-end;
		font-size: 12px;
		font-family: 'PingFang SC';
		font-weight: 500;
		margin-top: 20px;
		color: #FFFFFF;
	}
	.buttomtologin>span{
		color: #0078FF;
		cursor: pointer;
		margin-left: 10px;
	}
.xieyi {
	display: flex;
	align-items: center;
	font-size: 12px;
	font-family: ' PingFang SC';
	font-weight: 500;
	color: #3198ff;
	margin-left: 50px;
}
.forforget {
	display: flex;
	justify-content: space-between;
	font-size: 12px;
	margin-left: 50px;
	font-family: 'PingFang SC';
	color: #ffffff;
	margin-top: 16px;
}
.forforget > div {
	display: flex;
	align-items: center;
}
.forforget-regist {
	color: #0078ff;
	cursor: pointer;
	margin-left: 10px;
}
.top-header {
	display: flex;
	flex-direction: column;
	align-items: center;
}
.top-header > img {
	width: 480px;
	height: 340px;
}
.top-header > div {
	font-size: 36px;
	font-family: 'PingFang SC';
	font-weight: 400;
	color: #ffffff;
	opacity: 1;
}
.top-header > div:nth-of-type(2) {
	font-size: 16px;
	margin-bottom: 0px;
	margin-top: 10px;
	font-family: 'PingFang SC';
	font-weight: 300;
	letter-spacing: 3px;
	opacity: 0.7;
	color: #ffffff;
}
.img-b > div {
	width: 80px;
	height: 80px;
	cursor: pointer;
}
.img-b > div > img {
	width: 100%;
	height: 100%;
}
.codestyle {
	width: 100px;
	height: 30px;
	background: #ffffff;
	margin-bottom: 13px;
	margin-left: 260px;
	z-index: 99;
	border-radius: 3px;
	display: flex;
	align-items: center;
	cursor: pointer;
	justify-content: center;
	position: absolute;
}
.codestyle > span {
	font-size: 12px;
	color: #233045;
}
/deep/.el-input__inner {
	width:360px;
	border: 0px !important;
	background-color: #233045;
	color: white;
}

.imgicon {
	width: 36px;
	margin-top: 5px;
	height: 36px;
	margin-right: 10px;
}

/deep/.el-input--small {
	border: 0px !important;
}
.elinput {
	border-bottom: 1px solid #3f5063 !important;
	/* border-bottom: 2px solid #FFFFFF!important; */
}

.login-wrap {
	width: 100%;
	height: 100%;
	background-color: #233045;
}
.FormInput {
	padding-top: 5px;
}
</style>
